import React, { useEffect, useState } from "react";
import {
  Card,
  Box,
  Typography,
  IconButton,
  Grid,
  Avatar,
  Breadcrumbs,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Chip,
  TextField,
  Skeleton,
  Stack,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import CandidatePersonalDetailsForm from "./updateProfileForms/CandidatePersonalDetailsForm";
import { RiDeleteBin5Line } from "react-icons/ri";
import { CloseOutlined, Edit, ErrorOutline } from "@mui/icons-material";
import { FiEdit2 } from "react-icons/fi";
import { BsBriefcase } from "react-icons/bs";
import { useSelector } from "react-redux";
import { appSelector } from "../redux/selector";
import moment from "moment";
import logoImg from "../../Components/images/logo.png";
import Key from "../../clientVariables.json";
import { useDispatch } from "react-redux";
import axios from "axios";
import { PiCertificate } from "react-icons/pi";
import { toast } from "react-toastify";
import { HashLoader } from "react-spinners";

import {
  IoBriefcaseOutline,
  IoAddOutline,
  IoDocumentTextOutline,
  IoSchoolOutline,
} from "react-icons/io5";
import PersonalDetailsModal from "./Personaldetailsmodal";
import { getJobDBLocation, getResumeLocation } from "./getLocation";
import { userSelector } from "../user-redux/selector";
import PreferencesModal from "./Preferencesmodal";
import parse from "html-react-parser";

const CandidateDetailsView = ({
  candidateDetails,
  candidateRefreshHandlerDetailView,
  resume_id,
  file_name,
}) => {
  const [candidateData, setCandidateData] = useState({
    experience: [],
    education: [],
    certification: [],
    keySkills: [],
    profileSummary: "",
    preferences: [],
    personalDetails: {},
  });
  const { user } = useSelector(userSelector);

  const currentUser = useSelector((state) => state.UserReducer?.user);
  const [educationDetails, setEducationDetails] = useState([]);
  const [education, setEducation] = useState();
  const [certificateDetails, setCerticateDetails] = useState([]);
  const [projectDetails, setProjectDetails] = useState([]);
  const [personalDetails, setPersonalDetails] = useState([]);
  const [resumeDetails, setResumeDetails] = useState();
  const [skillSet, setSkillSet] = useState([]);
  const [open, setOpen] = useState(false);
  const [alignment, setAlignment] = useState("resume");
  const [loading, setLoading] = useState(false);
  const [profileLoading, setProfileLoading] = useState(!!resume_id);
  const [error, setError] = useState("");
  const dispatch = useDispatch(); // Initialize Redux dispatch
  const [profileDetails, setProfileDetails] = useState(null);
  const [showAllSkills, setShowAllSkills] = useState(false);
  const [keySkillsDialogOpen, setKeySkillsDialogOpen] = useState(false);
  const [editableSkills, setEditableSkills] = useState([]);
  const [newSkillInput, setNewSkillInput] = useState("");
  const [skillValidationError, setSkillValidationError] = useState("");

  // Certification dialog states
  const [certificationDialogOpen, setCertificationDialogOpen] = useState(false);
  const [editableCertifications, setEditableCertifications] = useState([]);
  const [selectedCertification, setSelectedCertification] = useState(null);
  const [isAddingCertification, setIsAddingCertification] = useState(false);
  const [certificationFormData, setCertificationFormData] = useState({
    cer_name: "",
    cer_year: null,
    cer_month_selected: false, // month is optional; track explicit selection
  });

  const { selectedCandidate } = useSelector(appSelector);
  const [formData, setFormData] = useState([
    {}, // form1Data
    {}, // form2Data
    {}, // form3Data
    {}, // form4Data
    {}, // form5Data
    {}, // form6Data
  ]);

  const primaryResumeDetails_ = useSelector(
    (state) => state.primaryResumeReducer?.resume
  );
  const [primaryResumeDetails, setPrimaryResumeDetails] = useState(
    primaryResumeDetails_
  );

  const updateModalState = (updates) => {
    setModalState((prevState) => ({
      ...prevState,
      ...updates,
    }));
  };
  const handleClose = () => {
    setModalState(initialState);
  };

  const handleOpen = (updates) => {
    updateModalState({ ...updates, isOpen: true });
  };

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  const initialState = {
    isOpen: false,
    open: null,
    initialData: null,
    loading: false,
    success: false,
  };

  const [modalState, setModalState] = useState(initialState);

  const skillsArray = resumeDetails?.ai_skills
    ? resumeDetails.ai_skills.split(",")
    : [];
  const displayedSkills = showAllSkills
    ? skillsArray
    : skillsArray.slice(0, 10);

  function calculateDuration(startDate, endDate, isCurrentProject) {
    const start = new Date(startDate);
    const end =
      endDate && isCurrentProject != 1 ? new Date(endDate) : new Date(); // Use current date if no end date

    let years = end.getFullYear() - start.getFullYear();
    let months = end.getMonth() - start.getMonth();

    // Adjust for cases where the month difference is negative
    if (months < 0) {
      years--;
      months += 12;
    }

    // Construct the duration string
    const durationYears = years > 0 ? `${years} yr${years > 1 ? "s" : ""}` : "";
    const durationMonths =
      months > 0 ? `${months} mo${months > 1 ? "s" : ""}` : "";

    // return `${moment(start).format("MMM YYYY")} - ${moment(end).format(
    //   "MMM YYYY"
    // )} · ${durationYears}${
    //   durationYears && durationMonths ? " " : ""
    // }${durationMonths}`.trim();
    return `${moment(start).isValid() ? moment(start).format("MMM YYYY") : "--"
      } - ${isCurrentProject == 1
        ? "Present"
        : moment(end).isValid()
          ? moment(end).format("MMM YYYY")
          : "--"
      } · ${durationYears}${durationYears && durationMonths ? " " : ""
      }${durationMonths}`.trim();
  }
  const formDataHnadler = (data, form) => {
    // Determine which form section to update based on the 'form' parameter
    const updatedFormData = formData.map((formSection, index) => {
      if (index === parseInt(form.charAt(1)) - 1) {
        // Convert 'f1', 'f2', ... to index
        return data; // Update the data for the corresponding form section
      }
      return formSection; // Keep other form sections unchanged
    });

    setFormData(updatedFormData);
  };

  const candidatesRefreshHandler = async () => {
    await candidateRefreshHandlerDetailView();
  };

  const getResumeDetails = async () => {
    setProfileLoading(true);
    try {
      const response = await axios.post(
        `${Key.domain}/candidate/get_js_profile_details`,
        {
          resume_id: resume_id,
        }
      );

      if (response.status === 200) {
        //console.log("Profile details fetched successfully:", response.data.data);
        setProfileDetails(response.data);
        setResumeDetails(response.data.data.resumedetails);
        setProjectDetails(response.data.data.projectdetails);
        setEducationDetails(response.data.data.educationdetails);
        setPersonalDetails(response.data.data.personaldetails);
        setCerticateDetails(response.data.data.certificatedetails);
        setSkillSet(
          response.data.data.resumedetails?.ai_skills
            ? response.data.data.resumedetails?.ai_skills?.split(",")
            : response.data.data.resumedetails?.skills
              ? response.data.data.resumedetails?.skills.split(",")
              : []
        );
        setError("");
      }
    } catch (err) {
      setError("Failed to fetch profile details");
      console.error("Error fetching profile details:", err);
    } finally {
      setProfileLoading(false);
    }
  };

  useEffect(() => {
    if (resume_id) {
      getResumeDetails();
    } else {
      setProfileLoading(false);
    }
  }, [resume_id]);

  const personalDetailsOnSubmit = async (formValues) => {
    // console.log(formValues);
    handleOpen({ loading: true, success: false });
    try {
      const response = await axios.put(
        `${Key.domain}/candidate/update_js_personal_details`,
        {
          user_id: candidateDetails?.user_id,
          session_token: currentUser?.session_token,
          resume_id:
            primaryResumeDetails?.id || primaryResumeDetails?.resume_id,
          SSN: formValues?.ssn_last_4,
          gender: formValues?.gender,
          date_of_birth: formValues?.dob,
          state: formValues?.state,
          city: formValues?.city,
          country: 233,
        }
      );
      if (response.status === 200) {
        const id = primaryResumeDetails?.id
          ? primaryResumeDetails?.id
          : primaryResumeDetails?.resume_id;
        fetch(id);
        handleOpen({ loading: false, success: true });
        handleClose();
        toast.success(response.data.data.msg);
        getResumeDetails();
        // Refresh the page after success
        // setTimeout(() => {
        //   window.location.reload();
        // }, 1000); // Wait 1 second before reloading (optional)
      } else {
        toast.error("Something went wrong..!");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const preferencesOnSubmit = async (formValues) => {
    //console.log("Form Values:", formValues);
    handleOpen({ loading: true, success: false });

    const jobType = formValues?.jobType || [];
    const visaType = formValues?.visaType || [];
    const relatedTitles = (formValues?.relatedTitles || []).map((title) =>
      title.replace(/'/g, "''")
    );

    const resume_id =
      primaryResumeDetails?.id ||
      primaryResumeDetails?.resume_id ||
      resumeDetails?.id;

    if (!resume_id) {
      toast.error("Resume ID is missing. Please refresh and try again.");
      handleOpen({ loading: false });
      return;
    }

    try {
      // Build the payload dynamically
      const payload = {
        user_id: candidateDetails?.user_id,
        session_token: currentUser?.session_token,
        resume_id: resume_id,
        jobtypes: jobType,
        visatypes: visaType,
        salarytype: formValues.rateType === "hour" ? 0 : 1,
        related_titles: relatedTitles.length ? relatedTitles.join(", ") : "",
        experience: formValues?.experience || 0,
        notice_period: formValues?.noticePeriod
          ? `${formValues.noticePeriod} days`
          : "0 days",
        state: formValues.state || "",
        city: formValues.city || "",
        country: formValues.country || "",
        willing_to_relocate: formValues?.willingRelocate ? "1" : "0",
        currently_on_project: formValues?.currentlyOnProject ? "1" : "0",
      };

      if (formValues.currentRate !== null && formValues.currentRate !== "") {
        payload.current_salary_start = formValues.currentRate;
        payload.current_salary_end = formValues.currentRate;
      }

      if (formValues.expectedRate !== null && formValues.expectedRate !== "") {
        payload.expected_salary_start = formValues.expectedRate;
        payload.expected_salary_end = formValues.expectedRate;
      }

      const response = await axios.put(
        `${Key.domain}/candidate/update_js_profile_preferences`,
        payload
      );

      if (response.status === 200) {
        fetch(resume_id);
        handleOpen({ loading: false, success: true });
        handleClose();
        toast.success(response.data.data.msg);
        getResumeDetails();
      } else {
        toast.error("Something went wrong..!");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "An unexpected error occurred."
      );
    } finally {
      handleOpen({ loading: false });
    }
  };

  // Key Skills Dialog Handlers
  const handleOpenKeySkillsDialog = () => {
    const currentSkills = resumeDetails?.ai_skills
      ? resumeDetails.ai_skills.split(",").map(skill => skill.trim()).filter(skill => skill !== "")
      : [];
    setEditableSkills(currentSkills);
    setNewSkillInput("");
    setSkillValidationError("");
    setKeySkillsDialogOpen(true);
  };

  const handleCloseKeySkillsDialog = () => {
    setKeySkillsDialogOpen(false);
    setNewSkillInput("");
    setSkillValidationError("");
  };

  const handleSkillInputChange = (e) => {
    setNewSkillInput(e.target.value);
    // Clear validation error when user starts typing
    if (skillValidationError) {
      setSkillValidationError("");
    }
  };

  const handleAddSkill = () => {
    const trimmedSkill = newSkillInput.trim();

    if (trimmedSkill === "") {
      setSkillValidationError("Please enter a skill");
      return;
    }

    // Check for duplicates (case-insensitive)
    const isDuplicate = editableSkills.some(
      skill => skill.toLowerCase() === trimmedSkill.toLowerCase()
    );

    if (isDuplicate) {
      setSkillValidationError("This skill already exists");
      return;
    }

    setEditableSkills([...editableSkills, trimmedSkill]);
    setNewSkillInput("");
    setSkillValidationError("");
  };

  const handleRemoveSkill = (skillToRemove) => {
    setEditableSkills(editableSkills.filter(skill => skill !== skillToRemove));
  };

  const handleSaveSkills = async () => {
    try {
      setLoading(true);
      const skillsString = editableSkills.join(", ");

      const response = await axios.post(
        `${Key.domain}/candidate/update_profile_summary_or_skills`,
        {
          session_token: currentUser?.session_token,
          user_id: candidateDetails?.user_id,
          resume_id: resume_id,
          skills: skillsString,
          category: "skills",
        }
      );

      if (response.status === 200) {
        toast.success("Skills updated successfully", {
          autoClose: 3000,
        });
        handleCloseKeySkillsDialog();
        getResumeDetails();
      } else {
        toast.error("Failed to update skills");
      }
    } catch (error) {
      console.error("Error updating skills:", error);
      toast.error("An error occurred while updating skills");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleAddSkill();
    }
  };

  // Certification Dialog Handlers
  const handleOpenCertificationDialog = () => {
    // Load current certifications
    setEditableCertifications(certificateDetails || []);
    setCertificationDialogOpen(true);
  };

  const handleAddCertification = () => {
    setIsAddingCertification(true);
    setSelectedCertification(null);
    setCertificationFormData({
      cer_name: "",
      cer_year: null,
    });
    setCertificationDialogOpen(true);
  };

  const handleCloseCertificationDialog = () => {
    setCertificationDialogOpen(false);
    setSelectedCertification(null);
    setIsAddingCertification(false);
    setCertificationFormData({
      cer_name: "",
      cer_year: null,
      cer_month_selected: false,
    });
  };

  const handleEditCertification = (cert) => {
    const rawYear = (cert?.cer_year || "").toString().trim();
    const monthSelected = !/^\d{4}$/.test(rawYear); // "YYYY" => month not selected

    setSelectedCertification(cert);
    setCertificationFormData({
      cer_name: cert.cer_name || "",
      // Accept both legacy "MMMM YYYY" and new "YYYY" formats
      cer_year: cert.cer_year
        ? moment(cert.cer_year, ["YYYY", "MMMM YYYY"], true).isValid()
          ? moment(cert.cer_year, ["YYYY", "MMMM YYYY"], true)
          : null
        : null,
      cer_month_selected: monthSelected,
    });
  };

  const handleCertificationFormChange = (field, value) => {
    setCertificationFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleUpdateCertification = () => {
    if (!selectedCertification) return;

    const updatedCerts = editableCertifications.map(cert =>
      cert.id === selectedCertification.id
        ? {
          ...cert,
          cer_name: certificationFormData.cer_name,
          cer_year: certificationFormData.cer_year
            ? certificationFormData.cer_month_selected
              ? certificationFormData.cer_year.format("MMMM YYYY")
              : certificationFormData.cer_year.format("YYYY")
            : ""
        }
        : cert
    );

    setEditableCertifications(updatedCerts);
    setSelectedCertification(null);
    setCertificationFormData({
      cer_name: "",
      cer_year: null,
    });
  };

  const handleSaveCertifications = async () => {
    // Validate certification name
    if (!certificationFormData.cer_name || certificationFormData.cer_name.trim() === "") {
      toast.error("Please enter a certification name");
      return;
    }

    try {
      setLoading(true);

      let updatedCertifications;
      let category;

      if (isAddingCertification) {
        // Adding new certification
        const newCertification = {
          id: null, // No ID for new certification
          cer_name: certificationFormData.cer_name,
          cer_year: certificationFormData.cer_year
            ? certificationFormData.cer_month_selected
              ? certificationFormData.cer_year.format("MMMM YYYY")
              : certificationFormData.cer_year.format("YYYY")
            : ""
        };
        updatedCertifications = [...(certificateDetails || []), newCertification];
        category = 'add';
      } else {
        // Editing existing certification
        const updatedCertification = {
          ...selectedCertification,
          cer_name: certificationFormData.cer_name,
          cer_year: certificationFormData.cer_year
            ? certificationFormData.cer_month_selected
              ? certificationFormData.cer_year.format("MMMM YYYY")
              : certificationFormData.cer_year.format("YYYY")
            : ""
        };
        updatedCertifications = certificateDetails.map(cert =>
          cert.id === selectedCertification.id ? updatedCertification : cert
        );
        category = 'update';
      }

      const response = await axios.post(
        `${Key.domain}/candidate/js_profile_certification_details`,
        {
          session_token: currentUser?.session_token,
          user_id: candidateDetails?.user_id,
          resume_id: resume_id,
          certificateData: updatedCertifications,
          category: category
        }
      );

      if (response.status === 200) {
        toast.success(isAddingCertification ? "Certification added successfully" : "Certification updated successfully", {
          autoClose: 3000,
        });
        handleCloseCertificationDialog();
        getResumeDetails();
      } else {
        toast.error(isAddingCertification ? "Failed to add certification" : "Failed to update certification");
      }
    } catch (error) {
      console.error("Error saving certification:", error);
      toast.error("An error occurred while saving certification");
    } finally {
      setLoading(false);
    }
  };

  const renderSectionCardSkeleton = (lineCount = 2) => (
    <Card sx={{ ...cardStyles, p: 2 }}>
      <Skeleton variant="rounded" width="35%" height={22} animation="wave" sx={{ mb: 2 }} />
      {Array.from({ length: lineCount }).map((_, index) => (
        <Box key={index} sx={{ display: "flex", gap: 1.5, mb: 2 }}>
          <Skeleton variant="rounded" width={50} height={50} animation="wave" />
          <Stack spacing={0.75} sx={{ flex: 1 }}>
            <Skeleton variant="rounded" width="75%" height={18} animation="wave" />
            <Skeleton variant="rounded" width="55%" height={14} animation="wave" />
            <Skeleton variant="rounded" width="100%" height={36} animation="wave" />
          </Stack>
        </Box>
      ))}
    </Card>
  );

  const renderProfileLoadingSkeleton = () => (
    <Box sx={{ p: 0 }}>
      <Grid container spacing={0}>
        <Grid item xs={12} md={6}>
          {renderSectionCardSkeleton(2)}
          {renderSectionCardSkeleton(1)}
          {renderSectionCardSkeleton(1)}
        </Grid>
        <Grid item xs={12} md={6}>
          <Card sx={{ ...cardStyles, p: 2 }}>
            <Skeleton variant="rounded" width="30%" height={22} animation="wave" sx={{ mb: 2 }} />
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {Array.from({ length: 8 }).map((_, index) => (
                <Skeleton
                  key={index}
                  variant="rounded"
                  width={index % 2 === 0 ? 88 : 72}
                  height={28}
                  animation="wave"
                />
              ))}
            </Box>
          </Card>
          <Card sx={{ ...cardStyles, p: 2 }}>
            <Skeleton variant="rounded" width="40%" height={22} animation="wave" sx={{ mb: 2 }} />
            <Skeleton variant="rounded" width="100%" height={14} animation="wave" sx={{ mb: 1 }} />
            <Skeleton variant="rounded" width="95%" height={14} animation="wave" sx={{ mb: 1 }} />
            <Skeleton variant="rounded" width="80%" height={14} animation="wave" />
          </Card>
          <Card sx={{ ...cardStyles, p: 2 }}>
            <Skeleton variant="rounded" width="35%" height={22} animation="wave" sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              {Array.from({ length: 4 }).map((_, index) => (
                <Grid item xs={6} key={index}>
                  <Skeleton variant="rounded" width="50%" height={12} animation="wave" sx={{ mb: 0.75 }} />
                  <Skeleton variant="rounded" width="70%" height={16} animation="wave" />
                </Grid>
              ))}
            </Grid>
          </Card>
          {renderSectionCardSkeleton(1)}
        </Grid>
      </Grid>
    </Box>
  );

  if (profileLoading) {
    return <div>{renderProfileLoadingSkeleton()}</div>;
  }

  if (error && !resumeDetails) {
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Typography variant="body1" sx={{ color: colors.third }}>
          {error}
        </Typography>
      </Box>
    );
  }

  return (
    <div>
      <Grid container spacing={0}>
        <Grid item xs={6}>
          {/* Experience Section */}
          <Grid item xs={12}>
            <Card sx={{ ...cardStyles, p: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  alignItems: "start",
                  mb: 2,
                  width: "100%",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: colors.primary,
                    fontWeight: 600,
                  }}
                >
                  Experience
                </Typography>
                {/* <IoAddOutline
                  onClick={() => {
                    // setProjectInitialData(null);
                    // setOpen("add_experience");
                    handleOpen({
                      open: "add_experience",
                      initialData: null,
                      loading: false,
                      success: false,
                    });
                  }}
                  style={{
                    color: "GrayText",
                    fontSize: "16px",
                    marginTop: "3px",
                    cursor: "pointer",
                  }}
                /> */}
              </Box>
              {projectDetails?.map((data, index) => (
                <Box
                  key={data?.id}
                  sx={{
                    display: "flex",
                    gap: 1,
                    mb: 2,
                    width: "100%",
                  }}
                >
                  <Avatar
                    variant="rounded"
                    sx={{
                      height: 50,
                      width: 50,
                      bgcolor: "#091E420F",
                      color: "#333",
                    }}
                    // src="https://img.freepik.com/free-vector/gradient-quill-pen-logo-with-tagline-template_23-2149813051.jpg?t=st=1733307736~exp=1733311336~hmac=1156eb336ddc9c4af268142c814304e30ccbfbeb2bd01f4c27696e0d21454d68&w=740"
                    src={data?.CompanyLogo ? data.CompanyLogo : ""}
                  >
                    <BsBriefcase style={{ fontSize: 26 }} />
                  </Avatar>
                  <Box sx={{ flexGrow: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        gap: 2,
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          color: colors.primary,
                          fontWeight: 600,
                          m: 0,
                        }}
                      >
                        {data?.pro_role || resumeDetails?.application_title}
                      </Typography>
                      {/* <Box sx={{ display: "flex", gap: 1 }}>
                        <FiEdit2
                          style={{
                            color: "GrayText",
                            fontSize: "14px",
                            marginTop: "3px",
                          }}
                          onClick={() => {
                            // setProjectInitialData(data);
                            // setOpen("add_experience");
                            handleOpen({
                              open: "add_experience",
                              initialData: data,
                              loading: false,
                              success: false,
                            });
                          }}
                        />
                      </Box> */}
                    </Box>
                    <Breadcrumbs separator="-" aria-label="breadcrumb">
                      <Typography
                        variant="body1"
                        sx={{
                          color: colors.secondary,
                          m: 0,
                          fontSize: "14px",
                        }}
                      >
                        {data?.pro_client}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          color: colors.secondary,
                          m: 0,
                          fontSize: "14px",
                        }}
                      >
                        {/* {(getValidValueReturnNull(
                          data?.job_type
                        ) &&
                          data?.job_type) ||
                          "Full-time"} */}
                      </Typography>
                    </Breadcrumbs>
                    <Typography
                      variant="body1"
                      sx={{
                        color: colors.third,
                        m: 0,
                        fontSize: "14px",
                      }}
                    >
                      {/* Aug 2021 - Present · 3 yrs 5 mos */}
                      {`${calculateDuration(
                        data?.pro_startdate,
                        data?.pro_enddate,
                        data?.is_current_project
                      )}`}
                    </Typography>
                    {/* <Typography
                      variant="body1"
                      sx={{
                        color: colors.third,
                        m: 0,
                        fontSize: "14px",
                      }}
                    >
                      {data?.pro_address_full}
                    </Typography> */}
                    <Box
                      //  sx={{
                      //   display: "flex",
                      //   gap: 1,
                      //   width: "100%",
                      //   overflowX: "auto", // Enables horizontal scrolling
                      //   whiteSpace: "nowrap", // Prevents wrapping of child elements
                      //   "&::-webkit-scrollbar": {
                      //     height: "8px", // Adjust scrollbar height
                      //   },
                      //   "&::-webkit-scrollbar-thumb": {
                      //     backgroundColor: colors.scrollThumb || "#888", // Custom scrollbar color
                      //     borderRadius: "4px",
                      //   },
                      //   "&::-webkit-scrollbar-thumb:hover": {
                      //     backgroundColor: colors.scrollThumbHover || "#555",
                      //   },
                      // }}
                      sx={{
                        display: "flex",
                        gap: 1,
                        flexWrap: "wrap",
                        // width: "100%",
                        // overflowX: "auto", // Enables horizontal scrolling
                        // whiteSpace: "nowrap", // Ensures items stay in a single line
                        // scrollBehavior: "smooth", // Smooth scrolling
                      }}
                    >
                      {data?.pro_technologies &&
                        data?.pro_technologies.split(",")?.length > 0 &&
                        data?.pro_technologies
                          .split(",")
                          .map((skill, index) => (
                            <Box
                              key={`skill-${index}`}
                              sx={{
                                bgcolor: colors.chipBG,
                                color: colors.chipText,
                                borderRadius: "4px",
                                p: "2px 4px",
                                fontSize: "10px",
                              }}
                            >
                              {skill}
                            </Box>
                          ))}
                    </Box>
                  </Box>
                </Box>
              ))}
            </Card>
          </Grid>

          {/* Education Section */}
          <Card sx={{ ...cardStyles, p: 2 }}>
            <Box
              sx={{
                display: "flex",
                gap: 1,
                alignItems: "start",
                mb: 2,
                width: "100%",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  color: colors.primary,
                  fontWeight: 600,
                }}
              >
                Education
              </Typography>
              {/* <IoAddOutline
                style={{
                  color: "GrayText",
                  fontSize: "14px",
                  marginTop: "3px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  // setEducationInitialData(null);
                  // setOpen("education");
                  handleOpen({
                    open: "education",
                    initialData: null,
                    loading: false,
                    success: false,
                  });
                }}
              /> */}
            </Box>
            {educationDetails?.map(
              (data) =>
                data?.edu_course && (
                  <Box
                    key={data?.id}
                    sx={{
                      display: "flex",
                      gap: 1,
                      mb: 1,
                      width: "100%",
                    }}
                  >
                    <Avatar
                      variant="rounded"
                      sx={{
                        height: 50,
                        width: 50,
                        bgcolor: "#091E420F",
                        color: "#333",
                      }}
                    // src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQdK_BdEjqYr_ff8r80vY3IhrIifxyZeZabOcVX&s=0"
                    >
                      <IoSchoolOutline style={{ fontSize: 26 }} />
                    </Avatar>
                    <Box sx={{ flexGrow: 1 }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          gap: 2,
                          width: "100%",
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            color: colors.primary,
                            fontWeight: 600,
                            m: 0,
                          }}
                        >
                          {data?.edu_course}
                        </Typography>
                        <Box sx={{ display: "flex", gap: 1 }}>
                          {/* <FiEdit2
                            style={{
                              color: "GrayText",
                              fontSize: "14px",
                              marginTop: "3px",
                            }}
                            onClick={() => {
                              // setEducationInitialData(data);
                              // setOpen("education");
                              handleOpen({
                                open: "education",
                                initialData: data,
                                loading: false,
                                success: false,
                              });
                            }}
                          /> */}
                        </Box>
                      </Box>
                      {data?.edu_university && (
                        <Typography
                          variant="body1"
                          sx={{
                            color: colors.secondary,
                            m: 0,
                            fontSize: "14px",
                          }}
                        >
                          {data?.edu_university}
                        </Typography>
                      )}
                      {data?.edu_starting_year && data?.edu_passing_year && (
                        <Typography
                          variant="body1"
                          sx={{
                            color: colors.third,
                            m: 0,
                            fontSize: "14px",
                          }}
                        >
                          {`${calculateDuration(
                            data?.edu_starting_year,
                            data?.edu_passing_year
                          )}`}
                        </Typography>
                      )}
                      {data?.statename && (
                        <Typography
                          variant="body1"
                          sx={{
                            color: colors.third,
                            m: 0,
                            fontSize: "14px",
                          }}
                        >
                          {`${data?.cityname}, ${data?.statename}`}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                )
            )}
          </Card>

          {/* Certification Section */}
          <Card sx={{ ...cardStyles, p: 2 }}>
            <Box sx={{ display: "flex", gap: 2, alignItems: "center", justifyContent: "space-between", mb: 2 }}>
              <Typography
                variant="body1"
                sx={{ color: colors.primary, fontWeight: 600 }}
              >
                Certification
              </Typography>
              <Button
                variant="outlined"
                size="small"
                startIcon={<IoAddOutline />}
                onClick={handleAddCertification}
                sx={{
                  textTransform: "none",
                  borderRadius: "6px",
                }}
              >
                Add
              </Button>
            </Box>
            {certificateDetails?.length > 0 ? (
              certificateDetails.map((certificate, index) => (
                <Box
                  key={index} // Add key for React rendering optimization
                  sx={{
                    display: "flex",
                    gap: 1,
                    mb: 1,
                    width: "100%",
                  }}
                >
                  <Avatar
                    variant="rounded"
                    sx={{
                      height: 50,
                      width: 50,
                      bgcolor: "#091E420F",
                      color: "#333",
                    }}
                  >
                    <PiCertificate style={{ fontSize: 26 }} />
                  </Avatar>
                  <Box sx={{ flexGrow: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 1,
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          color: colors.primary,
                          fontWeight: 600,
                          m: 0,
                        }}
                      >
                        {certificate.cer_name}
                      </Typography>
                      <FiEdit2
                        onClick={() => {
                          setSelectedCertification(certificate);
                          setCertificationFormData({
                            cer_name: certificate.cer_name || "",
                            // Accept both legacy "MMMM YYYY" and new "YYYY" formats
                            cer_year: certificate.cer_year
                              ? moment(certificate.cer_year, ["YYYY", "MMMM YYYY"], true).isValid()
                                ? moment(certificate.cer_year, ["YYYY", "MMMM YYYY"], true)
                                : null
                              : null,
                            cer_month_selected: !/^\d{4}$/.test((certificate?.cer_year || "").toString().trim()),
                          });
                          setCertificationDialogOpen(true);
                        }}
                        style={{
                          color: "GrayText",
                          fontSize: "14px",
                          marginTop: "3px",
                          cursor: "pointer",
                        }}
                      />
                    </Box>
                    <Typography
                      variant="body1"
                      sx={{
                        color: colors.secondary,
                        m: 0,
                        fontSize: "14px",
                      }}
                    >
                      {certificate.cer_year}
                    </Typography>
                  </Box>
                </Box>
              ))
            ) : (
              <Typography variant="body2" sx={{ color: colors.secondary }}>
                No certificates available.
              </Typography>
            )}
          </Card>

          {/* Certification Edit Dialog */}
          <Dialog
            open={certificationDialogOpen}
            onClose={handleCloseCertificationDialog}
            maxWidth="sm"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: "12px",
                boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.15)",
              },
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #e0e0e0",
                pb: 2,
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {isAddingCertification ? "Add Certification" : "Edit Certification"}
              </Typography>
              <IconButton
                onClick={handleCloseCertificationDialog}
                size="small"
                sx={{ color: "#666" }}
              >
                <CloseOutlined />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ pt: 3 }}>
              <Typography
                variant="body2"
                sx={{ color: "#666", my: 2 }}
              >
                Add details of Certifications you have completed
              </Typography>

              {/* Edit form */}
              <Box>

                <TextField
                  fullWidth
                  label="Certification Name"
                  required
                  value={certificationFormData.cer_name}
                  onChange={(e) => handleCertificationFormChange("cer_name", e.target.value)}
                  sx={{ mb: 2 }}
                  size="small"
                />

                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label="Certification Year"
                    views={['year', 'month']}
                    openTo="year"
                    format={certificationFormData.cer_month_selected ? "MMMM YYYY" : "YYYY"}
                    value={certificationFormData.cer_year}
                    onChange={(newValue) => {
                      handleCertificationFormChange("cer_year", newValue);

                      // If month got changed via picker, treat it as explicitly selected.
                      // (Year-only typing keeps monthSelected=false via textField handlers/onYearChange.)
                      if (newValue && moment(newValue).isValid()) {
                        const prev = certificationFormData.cer_year;
                        const prevMonth =
                          prev && moment.isMoment(prev) && prev.isValid()
                            ? prev.month()
                            : null;
                        const nextMonth = moment(newValue).month();

                        if (prevMonth !== null && nextMonth !== prevMonth) {
                          handleCertificationFormChange("cer_month_selected", true);
                        }
                      }
                    }}
                    onYearChange={(newYear) => {
                      // If user picks/types only a year, default month to January
                      // (avoids "Invalid date" and still supports month selection later)
                      const yearMoment = moment(newYear);
                      if (!yearMoment.isValid()) return;

                      const current = certificationFormData.cer_year;
                      const next = moment(current && moment.isMoment(current) ? current : undefined);

                      // Preserve existing month if already selected, otherwise January (0)
                      const monthToKeep =
                        current && moment.isMoment(current) && current.isValid()
                          ? current.month()
                          : 0;

                      const updated = (next && next.isValid() ? next : moment())
                        .year(yearMoment.year())
                        .month(monthToKeep)
                        .startOf("month");

                      handleCertificationFormChange("cer_year", updated);
                      handleCertificationFormChange("cer_month_selected", false);
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        placeholder: "YYYY or MMMM YYYY",
                        onChange: (e) => {
                          const raw = (e?.target?.value || "").trim();
                          // As soon as user types a 4-digit year, convert it to a valid month+year
                          // to prevent the picker from showing "Invalid date".
                          const isYearOnly = /^\d{4}$/.test(raw);
                          // Some invalid parses show up like "MMMM 2033" in the input.
                          const isMissingMonthToken = /^M{4}\s+\d{4}$/i.test(raw);
                          if (isYearOnly || isMissingMonthToken) {
                            const year = raw.match(/(\d{4})/)?.[1];
                            const parsed = year ? moment(year, "YYYY", true) : null;
                            if (parsed.isValid()) {
                              handleCertificationFormChange(
                                "cer_year",
                                parsed.month(0).startOf("month")
                              );
                              handleCertificationFormChange("cer_month_selected", false);
                            }
                          }
                        },
                        onBlur: (e) => {
                          const raw = (e?.target?.value || "").trim();
                          // Allow user to type only year (e.g., "2026")
                          const isYearOnly = /^\d{4}$/.test(raw);
                          const isMissingMonthToken = /^M{4}\s+\d{4}$/i.test(raw);
                          if (isYearOnly || isMissingMonthToken) {
                            const year = raw.match(/(\d{4})/)?.[1];
                            const parsed = year ? moment(year, "YYYY", true) : null;
                            if (parsed.isValid()) {
                              // Default to January for year-only entry
                              handleCertificationFormChange(
                                "cer_year",
                                parsed.month(0).startOf("month")
                              );
                              handleCertificationFormChange("cer_month_selected", false);
                            }
                          }
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </DialogContent>
            <DialogActions
              sx={{
                borderTop: "1px solid #e0e0e0",
                px: 3,
                py: 2,
              }}
            >
              <Button
                variant="outlined"
                onClick={handleCloseCertificationDialog}
                sx={{
                  textTransform: "none",
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSaveCertifications}
                variant="contained"
                disabled={loading}
                sx={{
                  textTransform: "none",
                  px: 3,
                }}
              >
                {loading ? "Saving..." : "Save"}
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>

        <Grid item xs={6}>
          {/* Key Skills Section */}
          <Card sx={{ ...cardStyles, p: 2 }}>
            <Box sx={{ display: "flex", gap: 1, alignItems: "start", mb: 2 }}>
              <Box sx={{
                display: "flex",
                gap: 2,
                alignItems: "start",
                mb: 2,
              }}>
                <Typography
                  variant="body1"
                  sx={{ color: colors.primary, fontWeight: 600 }}
                >
                  Key Skills
                </Typography>
                <FiEdit2
                  onClick={handleOpenKeySkillsDialog}
                  style={{
                    color: "GrayText",
                    fontSize: "14px",
                    marginTop: "3px",
                    cursor: 'pointer'
                  }} />
              </Box>
            </Box>
            {skillsArray.length > 0 ? (
              <>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {displayedSkills
                    .map((skill) => skill.trim())
                    .filter((skill) => skill !== "")
                    .map((skill, index) => (
                      <Chip
                        key={index}
                        label={skill.trim()}
                        sx={{
                          backgroundColor: colors.chipBackground,
                          color: colors.chipText,
                          textTransform: 'capitalize'
                        }}
                      />
                    ))}
                </Box>
                {skillsArray.length > 10 && (
                  <Box
                    sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}
                  >
                    <Button
                      onClick={() => setShowAllSkills(!showAllSkills)}
                      sx={{ color: colors.primary, textTransform: "none" }}
                    >
                      {showAllSkills ? "Show Less" : "Show More"}
                    </Button>
                  </Box>
                )}
              </>
            ) : (
              <Typography variant="body2" sx={{ color: colors.secondary }}>
                No skills are available.
              </Typography>
            )}
          </Card>

          {/* Key Skills Edit Dialog */}
          <Dialog
            open={keySkillsDialogOpen}
            onClose={handleCloseKeySkillsDialog}
            maxWidth="sm"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: "12px",
                boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.15)",
              },
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #e0e0e0",
                pb: 2,
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Update Skills
              </Typography>
              <IconButton
                onClick={handleCloseKeySkillsDialog}
                size="small"
                sx={{ color: "#666" }}
              >
                <CloseOutlined />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ pt: 3 }}>
              <Typography
                variant="body2"
                sx={{ color: "#666", my: 3 }}
              >
                Add, remove, or edit your skills below. This helps showcase your expertise to potential employers.
              </Typography>

              {/* Input field to add new skills */}
              <TextField
                fullWidth
                size="small"
                placeholder="Add a skill"
                value={newSkillInput}
                onChange={handleSkillInputChange}
                onKeyPress={handleKeyPress}
                error={!!skillValidationError}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                  },
                }}
              />

              {/* Error message with icon */}
              {skillValidationError && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    my: 1.5,
                    color: "#d32f2f"
                  }}
                >
                  <ErrorOutline sx={{ fontSize: "18px" }} />
                  <Typography variant="body2" sx={{ color: "#d32f2f" }}>
                    {skillValidationError}
                  </Typography>
                </Box>
              )}

              {/* Helper text */}
              {!skillValidationError && (
                <Typography variant="body2" sx={{ color: "#666", my: 1.5 }}>
                  Type a skill and press{" "}
                  <span style={{ fontWeight: 600, color: '#1976d2' }}>
                    Enter ⏎
                  </span>{" "}
                  to add it to the list
                </Typography>
              )}
              {/* <Button
                  variant="contained"
                  onClick={handleAddSkill}
                  sx={{
                    textTransform: "none",
                    borderRadius: "8px",
                    px: 3,
                    bgcolor: "#1976d2",
                    "&:hover": {
                      bgcolor: "#1565c0",
                    },
                  }}
                >
                  Add
                </Button> */}

              {/* Display editable skills as chips */}
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1,
                  minHeight: "100px",
                  p: 2,
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  bgcolor: "#fafafa",
                  overflow: "auto",
                  maxHeight: "300px",
                }}
              >
                {editableSkills.length > 0 ? (
                  editableSkills.map((skill, index) => (
                    <Chip
                      key={index}
                      label={skill}
                      onDelete={() => handleRemoveSkill(skill)}
                      deleteIcon={<CloseOutlined />}
                      sx={{
                        textTransform: 'capitalize',
                        fontWeight: 500,
                        "& .MuiChip-deleteIcon": {
                          color: '#747474ff',
                          pr: 0.5,
                          fontSize: "18px",
                          "&:hover": {
                            color: "#d32f2f",
                          },
                        },
                      }}
                    />
                  ))
                ) : (
                  <Typography
                    variant="body2"
                    sx={{ color: "#999", fontStyle: "italic", m: "auto" }}
                  >
                    No skills added yet. Type a skill and click "Add" to get started.
                  </Typography>
                )}
              </Box>
            </DialogContent>
            <DialogActions
              sx={{
                borderTop: "1px solid #e0e0e0",
                px: 3,
                py: 2,
              }}
            >
              <Button
                variant="outlined"
                onClick={handleCloseKeySkillsDialog}
                sx={{
                  textTransform: "none",
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSaveSkills}
                variant="contained"
                disabled={loading}
                sx={{
                  textTransform: "none",
                  px: 3,
                }}
              >
                {loading ? "Saving..." : "Save"}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Profile Summary Section */}

          <Card sx={{ ...cardStyles, p: 2 }}>
            <Box sx={{ display: "flex", gap: 1, alignItems: "start", mb: 2 }}>
              <Typography
                variant="body1"
                sx={{ color: colors.primary, fontWeight: 600 }}
              >
                Profile Summary
              </Typography>
            </Box>

            {resumeDetails?.summary ? (
              <Typography variant="body2" sx={{ color: colors.chipText }}>
                {parse(resumeDetails.summary)}
              </Typography>
            ) : (
              <Typography variant="body2" sx={{ color: colors.secondary }}>
                No profile summary available.
              </Typography>
            )}
          </Card>

          {/* Preferences Section */}
          <PreferencesModal
            // isOpen={open === "preferences" ? true : false}
            onClose={handleClose}
            onSubmit={preferencesOnSubmit}
            modalState={modalState}
          />
          <Card sx={{ ...cardStyles, p: 2 }}>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                alignItems: "start",
                mb: 2,
              }}
            >
              <Typography
                variant="body1"
                sx={{ color: colors.primary, fontWeight: 600 }}
              >
                Preferences
              </Typography>
              <FiEdit2
                style={{
                  color: "GrayText",
                  fontSize: "14px",
                  marginTop: "3px",
                }}
                onClick={() =>
                  // setOpen("preferences")
                  handleOpen({
                    open: "preferences",
                    initialData: resumeDetails || primaryResumeDetails, // Ensure one of these has valid data
                    loading: false,
                    success: false,
                  })
                }
              />
            </Box>
            <Grid container spacing={2}>
              {/* <Grid item xs={6}>
                <Box>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.secondary,
                      fontSize: "13px",
                    }}
                  >
                    Work Authorization
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.primary,
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {resumeDetails?.visatype_name || "--"}
                  </Typography>
                </Box>
              </Grid> */}
              <Grid item xs={6}>
                <Box>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.secondary,
                      fontSize: "13px",
                    }}
                  >
                    Job type
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.primary,
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {resumeDetails?.jobtypeNames}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6}>
                <Box>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.secondary,
                      fontSize: "13px",
                    }}
                  >
                    current rate
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.primary,
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    $ {(resumeDetails?.jobsalaryrangestart === 0) ? " " : resumeDetails?.jobsalaryrangestart}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.secondary,
                      fontSize: "13px",
                    }}
                  >
                    Currently On Project
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.primary,
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {resumeDetails?.iamavailable === null || resumeDetails?.iamavailable === undefined || resumeDetails?.iamavailable === ""
                      ? " "
                      : (resumeDetails?.iamavailable === "1" || resumeDetails?.iamavailable === 1
                        ? "Yes"
                        : "No")}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.secondary,
                      fontSize: "13px",
                    }}
                  >
                    expected rate
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.primary,
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    $ {(resumeDetails?.desiredsalarystart === 0) ? " " : resumeDetails?.desiredsalarystart}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.secondary,
                      fontSize: "13px",
                    }}
                  >
                    Willing to relocate
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.primary,
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {
                      resumeDetails?.willing_to_relocate === null ||
                        resumeDetails?.willing_to_relocate === undefined ||
                        resumeDetails?.willing_to_relocate === ""
                        ? ""
                        : resumeDetails?.willing_to_relocate === "1" || resumeDetails?.willing_to_relocate === 1
                          ? "Yes"
                          : "No"
                    }
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.secondary,
                      fontSize: "13px",
                    }}
                  >
                    Location
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.primary,
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {resumeDetails?.statename || resumeDetails?.cityname ? (
                      <>
                        {resumeDetails?.statename}
                        {resumeDetails?.statename && resumeDetails?.cityname ? ", " : ""}
                        {resumeDetails?.cityname}
                      </>
                    ) : (
                      ""
                    )}
                  </Typography>
                </Box>
              </Grid>
              {/* <Grid item xs={12}>
                <Box>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.secondary,
                      fontSize: "13px",
                    }}
                  >
                    Address
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.primary,
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {resumeDetails?.countryname}
                  </Typography>
                </Box>
              </Grid> */}
              <Grid item xs={12}>
                <Box>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.secondary,
                      fontSize: "13px",
                    }}
                  >
                    Related Titles
                  </Typography>
                  <Box
                    sx={{
                      mt: 0.5,
                      display: "flex",
                      gap: 1,
                      width: "100%",
                      flexWrap: "wrap",
                    }}
                  >
                    {/* {candidateDetails?.related_titles
                      ?.split(",") 
                      ?.map((role, index) => (
                        <Chip
                          key={index}
                          label={role}
                          size="small"
                          sx={{
                            bgcolor: colors.chipBG,
                            color: colors.chipText,
                            fontSize: 10,
                          }}
                        />
                      ))} */}

                    {(resumeDetails?.solr_search_string || "")
                      .split(",")
                      .map((role, index) => (
                        <Chip
                          key={index}
                          label={role}
                          size="small"
                          sx={{
                            bgcolor: colors.chipBG,
                            color: colors.chipText,
                            fontSize: 10,
                          }}
                        />
                      ))}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Card>

          {/* Personal Details Section */}

          <PersonalDetailsModal
            // isOpen={open === "personal_details" ? true : false}
            onClose={handleClose}
            onSubmit={personalDetailsOnSubmit}
            // initialData={personalDetails}
            modalState={modalState}
          />
          <Card sx={{ ...cardStyles, p: 2 }}>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                alignItems: "start",
                mb: 2,
              }}
            >
              <Typography
                variant="body1"
                sx={{ color: colors.primary, fontWeight: 600 }}
              >
                Personal details
              </Typography>
              {/* Enable edit icon for all users (or add your own condition) */}
              <FiEdit2
                style={{
                  color: "GrayText",
                  fontSize: "14px",
                  marginTop: "3px",
                  cursor: "pointer",
                }}
                onClick={() =>
                  handleOpen({
                    open: "personal_details",
                    initialData: personalDetails, // Pass current details for editing
                    loading: false,
                    success: false,
                  })
                }
              />
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Box>
                  <Typography
                    variant="body1"
                    sx={{ color: colors.secondary, fontSize: "13px" }}
                  >
                    Gender
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.primary,
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {personalDetails?.gender}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box>
                  <Typography
                    variant="body1"
                    sx={{ color: colors.secondary, fontSize: "13px" }}
                  >
                    Last 4 digits of SSN
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.primary,
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {personalDetails?.SSN === 0 ? (" ") : (personalDetails?.SSN)}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box>
                  <Typography
                    variant="body1"
                    sx={{ color: colors.secondary, fontSize: "13px" }}
                  >
                    Date of birth
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.primary,
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {personalDetails?.date_of_birth &&
                      personalDetails.date_of_birth !== "0000000" &&
                      moment(personalDetails.date_of_birth).isValid()
                      ? moment(personalDetails.date_of_birth).format("ll")
                      : ""}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box>
                  <Typography
                    variant="body1"
                    sx={{ color: colors.secondary, fontSize: "13px" }}
                  >
                    Location
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: colors.primary,
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {(personalDetails &&
                      getJobDBLocation({
                        cityname: personalDetails?.CityName,
                        statename: personalDetails?.StateName,
                      }) !== "N/A"
                      ? getJobDBLocation({
                        cityname: personalDetails?.CityName,
                        statename: personalDetails?.StateName,
                      })
                      : " "
                    )}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default CandidateDetailsView;

const cardStyles = {
  boxShadow:
    "rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px",
  borderRadius: "8px",
  margin: "10px 10px",
};

const colors = {
  third: "#888",
  chipBG: "#091E420F",
  chipText: "#333",
};
